// extracted by mini-css-extract-plugin
module.exports = {"DamageType":"DamageType_DamageType__1cS7L","CancelButton":"DamageType_CancelButton__1DHKg","NameInput":"DamageType_NameInput__3tzmG","ColorButton":"DamageType_ColorButton__1QS6J"};